import { useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import Link from "next/link";
import { gql, useQuery } from "@apollo/client";

import { ScheduleLegend } from "@/components/schedule";
import styles from "@/styles/Schedule.module.scss";
import PageHeader from "@/components/PageHeader";
import Seo from "@/components/seo";
import handleStaticProps from "src/lib/handle-static-props";

const Calendar = dynamic(() => import("@/components/schedule/Calendar"), {
  ssr: false,
});

export async function getStaticProps() {
  const { result } = await handleStaticProps({
    pageQuery,
  });
  return result;
}

function Schedule() {
  const { data } = useQuery(pageQuery);
  const router = useRouter();
  const [selectedDate, setSelectedDate] = useState();
  const scheduleBlocks = data?.allScheduleBlocks || [];

  const handleShowClick = (show) => {
    router.push(show);
  };
  const handleSelect = (e) => {
    const scheduleBlock = scheduleBlocks[e.target.value];
    if (!scheduleBlock) return;
    setSelectedDate(scheduleBlock.start);
  };

  return (
    <div className={`container ${styles.page}`}>
      <Seo title="Programming Schedule" />
      <header className={styles.header}>
        <PageHeader>Programming Schedule</PageHeader>
        <p>
          Browse shows by week, jump between semesters, and open a show to see
          more details.
        </p>
      </header>
      <div className={styles.mobileHint}>
        Swipe the calendar horizontally to see the full week.
      </div>
      <div className={styles.scheduleLayout}>
        <div id="calendar" className={styles.calendarColumn}>
          <div className={styles.scheduleControls}>
            <div>
              <label htmlFor="schedule-block">Semester</label>
              <p>Pick a schedule block to jump the calendar.</p>
            </div>
            <div className={styles.selectWrap}>
              <select
                id="schedule-block"
                name="show"
                className="form-control"
                onChange={handleSelect}
                defaultValue=""
              >
                <option value="" disabled>
                  Select a semester
                </option>
                {scheduleBlocks.map(({ id, name }, i) => (
                  <option value={i} key={id}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className={styles.calendarPanel}>
            <Calendar
              handleShowClick={handleShowClick}
              selectedDate={selectedDate}
            />
          </div>
        </div>
        <aside className={styles.legendColumn} aria-labelledby="legend-title">
          <h2 id="legend-title">Show types</h2>
          <ScheduleLegend />
        </aside>
      </div>
      <p className={styles.historyLink}>
        <Link href="/history/">
          Looking for a past song? Check out the history.
        </Link>
      </p>
    </div>
  );
}

export default Schedule;

const pageQuery = gql`
  query GetAllScheduleBlocks {
    allScheduleBlocks {
      id
      name
      start
      end
    }
  }
`;
